module.exports = __webpack_public_path__ + "static/images/drivingPermitExample-1.729af84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/drivingPermitExample-1.png
// module id = 8S1B
// module chunks = 0